const runInitialTenantConfiguration = () => {
    const configurationObject = document.querySelector("meta[property='configuration']");
    let content = {
        LOYALTY_URL: "",
        LOYALTY_TOKEN: "",
    };
    try {
        content = JSON.parse(configurationObject?.getAttribute("content") || "");
    }
    catch (error) {
        console.error("Error parsing configuration object", error);
    }
    window.configuration = content;
};
export default runInitialTenantConfiguration;
